import React from 'react';

import { useRouteChangeHandler } from 'shared/hooks';

import { ReactComponent as CartIcon } from '../../../assets/icons/ic_cart.svg';
import { ReactComponent as FavoriteIcon } from '../../../assets/icons/ic_favorite.svg';
import { ReactComponent as NoticeIcon } from '../../../assets/icons/ic_notifications.svg';
import { useGetNotificationCheck } from '../api/query';
import SupportIcon from './SupportIcon';

const ServiceIcons = ({ isLogin }: { isLogin: boolean }) => {
  const { data: hasNotification } = useGetNotificationCheck();

  const { handleRouteChange } = useRouteChangeHandler();

  return (
    <div className="flex items-center gap-x-7">
      <SupportIcon />

      <button
        aria-label="favorite"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'favorite',
            section: 'Service menu',
          });
          handleRouteChange('/shortlist');
        }}
      >
        <FavoriteIcon className="cursor-pointer text-black" width={24} height={24} />
      </button>

      <button
        aria-label="notice"
        className="relative"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'notice',
            section: 'Service menu',
          });
          handleRouteChange('/my/notifications');
        }}
      >
        <NoticeIcon className="cursor-pointer" width={24} height={24} />
        {isLogin && hasNotification && <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-primary"></div>}
      </button>

      <button
        aria-label="cart"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'cart',
            section: 'Service menu',
          });
          handleRouteChange('/carts');
        }}
      >
        <CartIcon className="cursor-pointer" width={24} height={24} />
      </button>
    </div>
  );
};

export default ServiceIcons;
